import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import lightOrDark from '@/utils/color/lightOrDark'
import css from './Block.module.scss'

type Props = {
  blockId: string
  isFirst: boolean
  isLast: boolean
}

const Block: React.FC<Props> = ({ blockId, isFirst = true, isLast = true }) => {
  const { colorId, title } = useSelector(
    migrationProjectSelector.getProjectBlockOrSymbolData(blockId),
    shallowEqual
  )

  const colorHex = useSelector(
    migrationProjectSelector.getProjectColorForUI(colorId)
  )

  const blockStyles = {
    '--block-color': colorHex,
  } as React.CSSProperties

  return (
    <div
      className={cx(css.container, {
        [css.light]: lightOrDark(colorHex) === 'dark',
        [css.dark]: lightOrDark(colorHex) === 'light',
        [css.last]: isLast,
        [css.first]: isFirst,
        [css.empty]: !title,
      })}
      style={blockStyles}
    >
      <div className={css.block}>
        <div className={css.name}>
          <div>{title}</div>
        </div>
      </div>
    </div>
  )
}

export default Block
